<template>
  <div>
    <div
      v-for="notification in notifications"
      :key="notification.id"
      role="alert"
      aria-live="polite"
      aria-atomic="true"
      class="sr_only"
    >
      <span v-if="notification.type === MESSAGE_SENT_NOTIFICATION">
        {{ i18n.$gettext('Message sent') }}
      </span>
      <span v-if="notification.type === NEW_MESSAGE_NOTIFICATION && !!recipientName(notification.data.scope)">
        {{
          i18n.$gettext('New message from %{sender_name} to %{recipient_name}', {
            sender_name: senderName(notification.data.partner),
            recipient_name: recipientName(notification.data.scope)
          })
        }}
      </span>
      <span v-if="notification.type === NEW_MESSAGE_NOTIFICATION && !recipientName(notification.data.scope)">
        {{ i18n.$gettext('New message from %{sender_name}', { sender_name: senderName(notification.data.partner) }) }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { NEW_MESSAGE_NOTIFICATION, MESSAGE_SENT_NOTIFICATION } from './store'

export default {
  name: 'ScreenReaderNotifications',
  data: () => ({ NEW_MESSAGE_NOTIFICATION, MESSAGE_SENT_NOTIFICATION }),
  computed: {
    ...mapGetters({
      notifications: 'getNotifications',
      getChatScopeByPath: 'getChatScopeByPath',
      chatScopes: 'getChatScopes'
    })
  },
  methods: {
    senderName(partner) {
      if (partner.publication) {
        return partner.publication.title
      } else {
        return `${partner.member.first_name} ${partner.member.last_name || ''}`
      }
    },
    recipientName(scopePath) {
      if (this.chatScopes.length === 1) {
        // no need to name the chat scope if there is only one
        return null
      }

      const scope = this.getChatScopeByPath(scopePath)
      if (scope.publication) {
        return scope.publication.title
      } else {
        return `${scope.user.first_name} ${scope.user.last_name || ''}`
      }
    }
  }
}

export { NEW_MESSAGE_NOTIFICATION, MESSAGE_SENT_NOTIFICATION }
</script>
